import NavigationViewModelT from '@/ViewModels/Views/NavigationViewModel';
import ViewFactory from '@/Factories/ViewFactory';
import ComponentManager from '@/Management/ComponentManager';
export default class NavigationViewFactory extends ViewFactory {
    public viewModel: any;
    public view: any;
    private NavigationViewModel: any;
    private NavigationView: any;
    constructor(params: any) {
        super(params);
        this.NavigationViewModel = ComponentManager.getViewModel<typeof NavigationViewModelT>('NavigationViewModel');
        this.NavigationView = ComponentManager.getView('NavigationView');
    }
    public getRegion(): string {
        return 'Navigation';
    }
    public getView(): any {
        if (this.viewModel == null) {
            this.viewModel = new this.NavigationViewModel({ viewFactory: this, locator: 'navigation' });
        }
        if (this.view == null) {
            this.view = new this.NavigationView(this.viewModel, this.createRootElement('LegacyNavigation'));
        }
        let tuple = this.view.getTuple();
        return tuple.view;
    }
}

ComponentManager.setFactory('LegacyNavigation', NavigationViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');